import React from 'react';
import AdminHome from '../components/Admin/AdminHome';

const AdminHomePage = ({match}) => {
    console.log(match);

    return (
        <>
            <div className='container-fluid'>
                <AdminHome />
            </div>       
        </>
    );
};

export default AdminHomePage;